import { Box } from '@factorialco/deprecated-design-system'

interface HalfWithBlockProps {
  content: React.ReactNode
  content2: React.ReactNode
}

const HalfWidthBlock = ({ content, content2 }: HalfWithBlockProps) => {
  return (
    <Box flexGrow width="full" justifyContent="center" alignItems="center" flexDirection="row">
      <Box justifyContent="center" style={{ width: '50%' }}>
        {content}
      </Box>
      <Box justifyContent="center" style={{ width: '50%' }}>
        {content2}
      </Box>
    </Box>
  )
}

export default HalfWidthBlock
